import { useState } from 'react';

export const ContactsPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        question: '',
        privacyAccepted: false,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;

        const fieldValue =
            type === 'checkbox'
                ? (e.target as HTMLInputElement).checked
                : value;

        setFormData((prev) => ({
            ...prev,
            [name]: fieldValue,
        }));
    };


    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        // Заглушка отправки
        if (!formData.privacyAccepted) {
            alert("Необходимо принять соглашение");
            return;
        }

        console.log("📝 Форма отправлена:", formData);
        alert("Форма успешно отправлена!");
    };

    return (
        <main className="layout__content">
            <section className="section layout__section contacts">
                <div className="container">
                    <div className="contacts__inner">
                        <div className="contacts__left">
                            <div className="contacts__image-wrapper contacts__image-wrapper_first">
                                <img className="contacts__image"
                                     src="/img/leftContact.png"
                                     alt=""/>
                            </div>
                        </div>
                        <div className="contacts__center">
                            <div className="contacts__block contacts-block">
                                <div className="contacts-block__inner">
                                    <h1 className="title contacts__title">Контакты</h1>

                                    <ul className="contacts__list">
                                        <li className="contacts__item contacts-item">
                                            <span className="contacts-item__label">Email:</span>
                                            <span className="contacts-item__value">
                                                <a className="contacts-item__link"
                                                   href="mailto:info@bionmax.ru">info@bionmax.ru</a>
                                            </span>
                                        </li>
                                        <li className="contacts__item contacts-item">
                                            <span className="contacts-item__label">Телефон:</span>
                                            <span className="contacts-item__value">
                                                <a className="contacts-item__link" href="tel:+74951507725">+7(495) 150-77-25</a>
                                            </span>
                                        </li>
                                    </ul>
                                    <div className="social-links contacts__social-links">
                                        <a className="social-links__link" href="" target="_blank">
                                            <svg className="svg-icon">
                                                <use href="img/sprite-icons.svg#telegram"></use>
                                            </svg>
                                        </a>
                                        <a className="social-links__link" href="" target="_blank">
                                            <svg className="svg-icon">
                                                <use href="img/sprite-icons.svg#vk"></use>
                                            </svg>
                                        </a>
                                        <a className="social-links__link" href="" target="_blank">
                                            <svg className="svg-icon">
                                                <use href="img/sprite-icons.svg#youtube"></use>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="contacts__right">
                            <div className="contacts__image-wrapper contacts__image-wrapper_last">
                                <img className="contacts__image" src="img/rightContact.png" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section layout__section questions">
                <div className="container">
                    <header className="section__header">
                        <h2 className="title section__title">Форма для вопросов</h2>
                    </header>
                    <div className="section__content">
                        <form className="form questions__form" onSubmit={handleSubmit}>
                            <fieldset className="form__fields">
                                <div className="form__row">
                                    <div className="input">
                                        <label htmlFor="name" className="input__label input-label">Имя</label>
                                        <label className="text-input">
                                            <input
                                                id="name"
                                                name="name"
                                                className="text-input__input"
                                                placeholder="Мария"
                                                type="text"
                                                required
                                                value={formData.name}
                                                onChange={handleChange}
                                            />
                                        </label>
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="input">
                                        <label htmlFor="email" className="input__label input-label">E-Mail</label>
                                        <label className="text-input">
                                            <input
                                                id="email"
                                                name="email"
                                                className="text-input__input"
                                                placeholder="example@gmail.com"
                                                type="email"
                                                required
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </label>
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="input">
                                        <label htmlFor="question" className="input__label input-label">Вопрос</label>
                                        <label className="text-input">
                                            <textarea
                                                id="question"
                                                name="question"
                                                className="text-input__input"
                                                rows={3}
                                                required
                                                value={formData.question}
                                                onChange={handleChange}
                                            />
                                        </label>
                                    </div>
                                </div>
                                <div className="form__row">
                                    <label className="checkbox-input">
                                        <input
                                            name="privacyAccepted"
                                            className="checkbox-input__input"
                                            type="checkbox"
                                            checked={formData.privacyAccepted}
                                            onChange={handleChange}
                                        />
                                        <span className="checkbox-input__label">
                                            <span className="checkbox-input__label-text">
                                                Нажимая кнопку, я принимаю <a
                                                className="form__link"
                                                href=""
                                                target="_blank">Соглашение об обработке персональных данных</a>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                            </fieldset>
                            <fieldset className="form__submit">
                                <button className="button button_outline" type="submit">Отправить</button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    );
};
